
const HeroSection = () => {
  return (
    <section className="relative bg-gradient-to-br from-slate-900 to-slate-800 text-white py-24">
      <div 
        className="absolute inset-0 bg-cover bg-center opacity-20"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/9622f50c11f935e34f3f02285a89d945.jpg')`
        }}
      />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <h1 className="text-5xl font-bold mb-6">
            Building Global Bridges for 
            <span className="text-teal-400"> Small Businesses</span>
          </h1>
          <p className="text-xl text-gray-300 mb-8 leading-relaxed">
            We're a team of e-commerce experts, international trade specialists, and growth strategists 
            who believe every small business deserves to compete on the global stage.
          </p>
          <div className="flex flex-wrap gap-6 text-sm">
            <div className="flex items-center">
              <i className="ri-global-line text-teal-400 mr-2"></i>
              <span>12+ Countries Served</span>
            </div>
            <div className="flex items-center">
              <i className="ri-team-line text-teal-400 mr-2"></i>
              <span>15+ Years Combined Experience</span>
            </div>
            <div className="flex items-center">
              <i className="ri-award-line text-teal-400 mr-2"></i>
              <span>Certified International Trade Experts</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
